import Form from "react-bootstrap/Form";
import {useTranslation} from "react-i18next";
import {useEffect} from "react";

const WasteTypesSelect = (
    {
        prefix = "",
        multiple = false,
        disabled = false,
        onChange,
        value,
        defaultValue
    }
) => {
    const [_Tc] = useTranslation("choices");
    const selectProps = {};

    if (value !== undefined) {
        selectProps.value = value;
    } else if (defaultValue !== undefined) {
        selectProps.defaultValue = defaultValue;
    } else {
        selectProps.defaultValue = "";
    }
    if (onChange !== undefined) {
        selectProps.onChange = onChange;
    }

    return (
        <Form.Select
            aria-label="Selector de tipos de residuos"
            name={prefix + "waste_type"}
            disabled={disabled}
            {...selectProps}
        >
            <option value="">{_Tc("labels.all")}</option>
            <option value="pg">{_Tc("wastes.pg")}</option>
            <option value="pc">{_Tc("wastes.pc")}</option>
            <option value="gl">{_Tc("wastes.gl")}</option>
            <option value="oc">{_Tc("wastes.oc")}</option>
            <option value="tx">{_Tc("wastes.tx")}</option>
            <option value="ol">{_Tc("wastes.ol")}</option>
            <option value="rg">{_Tc("wastes.rg")}</option>
            <option value="rt">{_Tc("wastes.rt")}</option>
            <option value="bs">{_Tc("wastes.bs")}</option>
            <option value="pr">{_Tc("wastes.pr")}</option>
            <option value="ml">{_Tc("wastes.ml")}</option>
            <option value="ot">{_Tc("labels.other")}</option>
        </Form.Select>
    )

}
export default WasteTypesSelect